export const SET_DMX_PROFILE_CHANNELS = 'SET_DMX_PROFILE_CHANNELS';
export const SET_DMX_PROFILE_CHANNELS_SUCCESSFUL = 'SET_DMX_PROFILE_CHANNELS_SUCCESSFUL';
export const SET_DMX_PROFILE_CHANNELS_FAILED = 'SET_DMX_PROFILE_CHANNELS_FAILED';
